const middlewareUrl = process.env.REACT_APP_MIDDLEWARE_URL;
const technicalWork = process.env.REACT_APP_TECHNICAL_WORK;

const profileName = process.env.REACT_APP_PROFILE_NAME ?? 'ТВІЙ ГАЗЗБУТ';
const profileEmail = process.env.REACT_APP_PROFILE_EMAIL ?? 'digital@gaszbut.com.ua';

const projectType = process.env.REACT_APP_PROJECT_TYPE ?? 'tviygas';

export { middlewareUrl, technicalWork, profileName, profileEmail, projectType};
